<template>
  <div>
    <div v-for="label in labels.filter(l => l.dateTime.split('T')[0] === date && l.vehicle.id === vehicleId)" :key="label.id" class="col label" :style="{ backgroundColor: this.color }" >
      <Popper placement="right" :show="openedPopperId === label.id">
        <span role="button" @click="showEditPopper(label)">
          {{ label.title }}
        </span>
        <template #content v-if="permissions.canUseAutomaticLabels">
          <div>
            <button class="btn btn-sm btn-danger d-block w-100 mb-2" @click="closeEditPopper">
              Zamknij edytor <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <label for="date">Przenieś etykietę</label>
          <template v-if="editableLabel">
            <input id="date" class="form-control mb-2" type="date" v-model="editableDate">
            <input class="form-control" type="time" v-model="editableTime">
          </template>
          <div v-if="editableLabel">
            <button class="btn btn-primary mt-1" @click="saveNewDate(editableLabel)">Zapisz</button>
            <button class="btn btn-danger d-block mt-1" @click="deleteLabel(editableLabel)">Usuń</button>
          </div>
          <hr>
          <template v-if="editableLabel">
            {{ editableLabel.dateTime.replace('T', ' ') }}
          </template>
          <div v-if="label.title.startsWith('Zmiana*')">
            <form @submit.prevent="ConfirmLabel(label.id)">
              <input type="datetime-local" class="form-control mb-3" placeholder="Data startu" v-model="startDate" required>
              <button class="btn btn-primary" type="submit">
                Zatwierdź
              </button>
            </form>
          </div>

          <div v-if="label.title.startsWith('45 od')">
            <button class="btn btn-primary" @click="From40Change(label.id)">
              Zmień na 2x24
            </button>
          </div>

          <div v-if="label.title.startsWith('2x24')">
            <button class="btn btn-primary" @click="changeTo45From(label.id)">
              zmień na 45 od
            </button>
          </div>
        </template>
      </Popper>
    </div>
  </div>
</template>

<script>
import Popper from 'vue3-popper'
import axios from 'axios'
import swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import moment from 'moment-timezone'
import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'

export default {
  components: { Popper },
  props: ['date', 'vehicleId'],
  data () {
    return {
      color: 'yellow',
      startDate: '',
      openedPopperId: null,
      moment: moment,
      editableLabel: null,
      editableDate: null,
      editableTime: null
    }
  },
  computed: {
    ...mapGetters({
      labels: 'automaticLabelsModule/getLabels',
      permissions: 'permissionModule/getPermissions'
    })
  },
  // mounted () {
  //   // when this.labels is changed then this function will be called
  //   this.$watch('labels', () => {
  //     // sort array to make label witch name starts with "zmiana" to be at the end of array
  //     // eslint-disable-next-line vue/no-mutating-props
  //     this.labels.sort((a, b) => {
  //       if (a.title.startsWith('Zmiana')) {
  //         return 1
  //       } else {
  //         return -1
  //       }
  //     })
  //
  //     this.labels.forEach(label => {
  //       label.time = `${label.dateTime.split('T')[1].split(':')[0]}:${label.dateTime.split('T')[1].split(':')[1]}`
  //       this.date = label.dateTime.split('T')[0]
  //     })
  //   })
  // },
  methods: {
    ConfirmLabel (id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      // convert startDatetime to 2023-01-11T14:48:57.380Z format
      const postdata = {
        labelId: id,
        startDateTime: `${this.startDate}:57.380Z`
      }

      axios.post(process.env.VUE_APP_API_BASE_URL + 'Label/Automatic/Confirm/' + id, postdata, config)
        .then(() => {
          swal.fire({
            type: 'success',
            title: 'Sukces',
            text: 'Zmiana została zatwierdzona',
            icon: 'success'
          })
          emitter.emit('automaticLabelAdded')
          this.openedPopperId = null
        }).catch((e) => {
          if (e.response.status === 400 && e.response.data === 'Start date time for new cycle cannot be before Zmiana*') {
            swal.fire({
              type: 'info',
              title: 'Data rozpoczęcia nowego cyklu nie może być wcześniejsza niż Zmiana*',
              text: '',
              icon: 'info'
            })
          } else {
            swal.fire('Coś poszło nie tak', '', 'error')
          }
        })
    },
    changeTo45From (id) {
      $axios.post(`Label/Automatic/2x24/45From/${id}`, { labelId: id })
        .then(() => {
          emitter.emit('automaticLabelAdded')
          this.openedPopperId = null
          Swal.fire({
            type: 'success',
            title: 'Sukces',
            text: 'Zmiana została zatwierdzona',
            icon: 'success'
          })
        })
    },

    async deleteLabel (label) {
      try {
        await $axios.delete(`Label/${label.id}`)

        emitter.emit('automaticLabelAdded')
        this.openedPopperId = null

        await Swal.fire({
          type: 'success',
          title: 'Sukces',
          text: 'Etykieta została usunięta',
          icon: 'success'
        })
      } catch (e) {
        await Swal.fire({
          type: 'error',
          title: 'Błąd',
          text: 'Nie udało się usunąć etykiety',
          icon: 'error'
        })
      }
    },

    async saveNewDate (label) {
      const putData = {
        dateTime: this.editableDate !== null ? `${this.editableDate}T${this.editableTime}` : this.date,
        TimeNotProvided: this.editableTime === null
      }

      try {
        await $axios.put(`Label/Automatic/${label.id}`, putData)
        emitter.emit('automaticLabelAdded')
        this.openedPopperId = null
        await Swal.fire('Sukces', 'Data została zapisana', 'success')
      } catch (e) {
        if (e.response?.data === 'Cannot change date. Date cam be changed only for START, ZMIANA and 24 od labels.') {
          await Swal.fire({
            type: 'info',
            title: 'Błąd',
            text: 'Data może być zmieniona jedynie dla etykiety START, ZMIANA oraz 24 od',
            icon: 'info'
          })
        } else if (e.response?.data === 'Cannot change date. Next change is already confirmed.') {
          await Swal.fire({
            type: 'info',
            title: 'Błąd',
            text: 'Nie można zmienić daty etykiety, ponieważ kolejna zmiana jest już zatwierdzona.',
            icon: 'info'
          })
        } else if (e.response?.data === 'Cannot update label in the finished chain!') {
          await Swal.fire({
            type: 'info',
            title: 'Błąd',
            text: 'Nie można zmienić daty etykiety dla zakończonego cyklu etykiet.',
            icon: 'info'
          })
        } else {
          await Swal.fire('Błąd', 'Nie udało się zapisać daty', 'error')
        }
      }
    },
    From40Change (id) {
      const postdata = { labelId: id }

      $axios.post(`Label/Automatic/45From/2x24/${id}`, postdata).then(() => {
        emitter.emit('automaticLabelAdded')
        this.openedPopperId = null
        Swal.fire({
          type: 'success',
          title: 'Sukces',
          text: 'Poprawnie zapisano zmiany',
          icon: 'success'
        })
      }).catch(error => {
        console.log(error)
        Swal.fire({
          type: 'info',
          title: 'Błąd',
          text: 'Nie udało się zapisać zmian, następna etykieta jest już zatwierdzona.',
          icon: 'info'
        })
      })
    },
    async reFetchLabels () {
      const fromDate = `${this.date}T00:00:00`
      const toDate = `${this.date}T23:59:59`

      this.labels = (await $axios(`Label?vehicleIds=${this.vehicleId}&fromDate=${fromDate}&toDate=${toDate}`)).data
    },

    showEditPopper (label) {
      this.openedPopperId = label.id
      this.editableLabel = label
      this.editableDate = moment(label.dateTime).tz('Europe/Warsaw').format('YYYY-MM-DD')
      this.editableTime = moment(label.dateTime).tz('Europe/Warsaw').format('HH:mm')
    },

    closeEditPopper () {
      this.openedPopperId = null
      this.editableLabel = null
      this.editableDate = null
      this.editableTime = null
    }
  }
}
</script>

<style scoped>
.label {
  font-size: 0.7em;
  display: inline-block;
  padding: 5px;
  text-align: justify;
  margin-right: 3px;
  border-radius: 5px;
  font-weight: 700;
}
</style>
